module.exports = __webpack_public_path__ + "static/media/Morph1.b0b7cc4c.png";